<template>
  <v-app v-if="authenticate()">
    <dashboard-core-app-bar />

    <dashboard-core-drawer />

    <dashboard-core-view />

    <dashboard-core-settings />

    <base-material-snackbar
            v-model="snackbar.show"
            :type="snackbar.color"
            v-bind="{
              [snackbar.direction[0]]: true,
              [snackbar.direction[1]]: true,
            }">{{snackbar.text}}</base-material-snackbar>
  </v-app>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),
    computed: {
      ...mapState(['loggedIn', 'snackbar']),
    },
    methods: {
      authenticate() {
        return this.loggedIn || this.$router.push("/login")
      }
    }
  }
</script>
